import { handleErrors } from '.';

export const APIgetOverallStats = async () => (
  window.axios.get(`/api/stats`)
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);
